(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('FrequencyDeleteController',FrequencyDeleteController);

    FrequencyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Frequency'];

    function FrequencyDeleteController($uibModalInstance, entity, Frequency) {
        var vm = this;

        vm.frequency = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Frequency.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
